import Avatar from 'flarum/common/components/Avatar';
export default function avatar(user, attrs) {
  if (attrs === void 0) {
    attrs = {};
  }
  return m(Avatar, Object.assign({
    user: user
  }, attrs));
}
flarum.reg.add('v17development-blog', 'common/helpers/avatar', avatar);